import React from 'react';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react';
import { Button } from '@components/ui/button';
import { links } from '../../../core/router';
import { useSearchReducer } from '../../../components/hooks/useSearchReducer';
import { injectTSDI } from '../../../core/tsdi';
import { Api } from '../../../core/api';
import { useWrapRequest } from '../../../components/hooks/use-wrap-request';
import { EmployeeContext } from '..';
import { CellProps, TableComponent } from '../../../components/table';
import { CustomFacilitySearchDto } from '../../../core/api/StudioClient';

export default observer(() => {
    const navigate = useNavigate();
    const { studioClient } = injectTSDI(Api);
    const employee = React.useContext(EmployeeContext);

    const [searchParams, dispatch] = React.useReducer(useSearchReducer, {
        size: 30,
        page: 0
    });

    const facilities = useWrapRequest(
        async (searchParams, employee) => {
            const result =
                await studioClient.v1.customFacilityControllerGetPage({
                    ...searchParams,
                    creatorMySportsId: employee.mySportsId
                });

            return { ...result.data, content: result.data.content || [] };
        },
        { defaultData: { content: [] }, deps: [searchParams, employee] }
    );

    return (
        <TableComponent<CustomFacilitySearchDto[]>
            emptyText="This employee did not create any facilities"
            items={facilities}
            columns={[
                {
                    Header: 'Name',
                    Cell: ({
                        row: {
                            original: { name, id }
                        }
                    }: CellProps<CustomFacilitySearchDto>) => (
                        <Button
                            variant="link"
                            className="h-auto p-0"
                            onClick={() =>
                                void navigate(links.facilityEdit(id))
                            }
                        >
                            {name}
                        </Button>
                    )
                },
                {
                    Header: 'Category',
                    Cell: ({
                        row: {
                            original: { category }
                        }
                    }: CellProps<CustomFacilitySearchDto>) => category.label
                },
                {
                    Header: 'Address',
                    Cell: ({
                        row: {
                            original: { address }
                        }
                    }: CellProps<CustomFacilitySearchDto>) =>
                        `${address.street} ${address.houseNumber}, ${address.city}`
                }
            ]}
            onPageSizeChange={(size) => dispatch({ type: 'size', size })}
            onChangePage={(page) =>
                void dispatch({
                    type: 'page',
                    page
                })
            }
        />
    );
});
